import request from 'superagent'

class Paginated {
  constructor(url, callback) {
    this.url = url
    this.callback = callback
    this.results = []
  }

  getPage = url => {
    return new Promise((resolve, reject) => {
      console.log(`GET ${url}`)
      request.get(url).then(resolve).catch(reject)
    })
  }

  handler = response => {
    const { data, links } = response.body
    if (!data) {
      throw new Error('Missing data from response')
    }
    if (!links) {
      throw new Error('Missing links from response')
    }
    this.results = this.results.concat(data)
    if (typeof this.callback === 'function') {
      this.callback(data)
    }
    if (!links.next) {
      this.resolve(this.results)
    } else {
      this.getPage(links.next).then(this.handler).catch(this.reject)
    }
  }

  get() {
    return new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
      const page = this.getPage(this.url).then(this.handler).catch(this.reject)
    })
  }
}

/// Get a paginated collection of data.
const paginated = (url, callback) => {
  return new Paginated(url, callback).get()
}

export default paginated
